/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_SavedInputs */

const vi_online_price_saved = /** @type {(inputs: Online_Price_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu giá Online`)
};

/**

* @param {Online_Price_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_saved = /** @type {((inputs?: Online_Price_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_saved(inputs)
});